import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loginScreen withAccordion" }
const _hoisted_2 = { class: "popUpWindow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "primaryLine" }, null, -1)
const _hoisted_4 = { class: "contentLogin" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { for: "username" }
const _hoisted_7 = { class: "p-float-label error-label" }
const _hoisted_8 = { for: "password" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "primaryLine" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "primaryLine" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Sipass = _resolveComponent("Sipass")!
  const _component_Rekono = _resolveComponent("Rekono")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Accordion, { activeIndex: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, null, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("global.login")) + " ", 1),
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("form", null, [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_InputText, {
                      id: "username",
                      type: "text",
                      modelValue: _ctx.form.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                      name: "username",
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.login()), ["enter"]))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("login.username")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_Password, {
                      id: "password",
                      "toggle-mask": true,
                      modelValue: _ctx.form.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.password) = $event)),
                      name: "password",
                      feedback: false,
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.login()), ["enter"]))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("login.password")), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.errors), 1)
                  ]),
                  _createVNode(_component_Button, {
                    "event-name": "loginButtonClick",
                    "event-from": "/login",
                    class: "submitButton defaultButton",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.login())),
                    label: _ctx.$t(`login.press_to_login`)
                  }, null, 8, ["label"]),
                  _createElementVNode("a", {
                    class: "link",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'ForgottenPassword' }))),
                    onKeypress: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.$router.push({ name: 'ForgottenPassword' })), ["enter"])),
                    tabindex: "0"
                  }, _toDisplayString(_ctx.$t("login.forgotten_password")), 33),
                  _createElementVNode("a", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'Register' }))),
                    onKeypress: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.$router.push({ name: 'Register' })), ["enter"])),
                    class: "link",
                    tabindex: "0"
                  }, _toDisplayString(_ctx.$t("login.not_a_user")), 33)
                ])
              ])
            ]),
            _: 1
          }),
          (_ctx.sipassEnabled)
            ? (_openBlock(), _createBlock(_component_AccordionTab, { key: 0 }, {
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("login.sipass_login")) + " ", 1),
                  _hoisted_9
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Sipass)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.rekonoEnabled)
            ? (_openBlock(), _createBlock(_component_AccordionTab, { key: 1 }, {
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("login.rekono_login")) + " ", 1),
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Rekono)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}